// src/styles/formClasses.ts
import {
  primaryBtnModernClasses,
  secondaryBtnModernClasses,
} from "./uiClasses";

export const formInputClasses =
  "w-full rounded-2xl border border-[#ddd1bf] bg-white px-4 py-3 text-sm text-[#213547] shadow-[0_10px_30px_rgba(84,62,39,0.06)] placeholder:text-[#8d877e] focus:outline-none focus:ring-4 focus:ring-[#f5d9bf]";

export const formTextAreaClasses =
  "w-full rounded-2xl border border-[#ddd1bf] bg-white px-4 py-3 text-sm text-[#213547] shadow-[0_10px_30px_rgba(84,62,39,0.06)] focus:outline-none focus:ring-4 focus:ring-[#f5d9bf] min-h-[120px]";

export const formLabelClasses = "mb-1 block text-sm font-medium text-[#31495a]";

export const formErrorClasses = "mt-1 text-xs text-red-500";

// Buttons (alias to global)
export const btnPrimary = primaryBtnModernClasses;
export const btnSecondary = secondaryBtnModernClasses;

// Full-width form submit button used on auth/contact pages
export const formBtnPrimaryClasses =
  `w-full ${primaryBtnModernClasses}`;
